import React, {useEffect, useState} from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  Alert
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import {Link} from "react-router-dom";
import * as fb from '../../firebase';
import {addAdminLog} from "components/Helper/index";
import "./ProductGroup.css";
import StringArrayInput from "../../components/StringArrayInput/StringArrayInput";

const EditProductGroup = (props) => {
  const [product, setProduct] = useState({})
  const [products, setProducts] = useState([])
  const [error, setError] = useState("")
  const [errors, setErrors] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [disabledSave, setDisabledSave] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [prices, setPrices] = useState({})
  const ref = props.match.params.ref;
  const pIndex = props.match.params.index;

  useEffect(() => {
    console.log('ref',ref)
    console.log('pIndex',pIndex)
    getData()
    getProducts()
    fetchPrices()
  }, []);

  const getData = () => {
    fb.metaCollection.doc(`shopify_${ref === 'rb' ? '' : `${ref}_`}products`).get().then((doc) => {
      if(doc.exists && doc.data().hasOwnProperty('ids')){
        let ids = doc.data().ids
        setProduct(ids[pIndex])
        console.log('data',ids[pIndex])
      }
    })
  }

  const getProducts = () => {
    fb.productsCollection.get().then((query) => {
      if(!query.empty){
        let  prs = []
        query.docs.forEach(doc => {
          prs.push({
            title: doc.data().title,
            ref: doc.data().ref
          })
        })
        setProducts(prs.sort((a, b) => {
          const numA = parseInt(a.ref.match(/\d+/)?.[0] || '0', 10);
          const numB = parseInt(b.ref.match(/\d+/)?.[0] || '0', 10);
          return numA - numB;
        }))
      }
    })
  }

  const fetchPrices = async () => {
    fb.metaCollection.doc(`PartnersPrices`).get().then((doc) => {
      if(doc.exists){
        console.log('prices', doc.data())
        setPrices(doc.data())
      }
    })
  }

  const orderOptions = () => {
    let out = []
    for (let i = 0; i < 100; i++) {
      out.push(<option key={i} value={i+1}>{i+1}</option>)
    }
    return out
  }

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if(!product.name){
      formIsValid = false;
      errors["name"] = "Title is required";
    }

    if(ref !== 'rb' && !product.order){
      formIsValid = false;
      errors["order"] = "Order is required";
    }

    if((ref === 'rb' && !product.id) || (ref !== 'rb' && (!product.id || product.id.length === 0))){
      formIsValid = false;
      errors["id"] = "Id is required";
    }

    if(ref !== 'rb' && (!product.products || product.products.length === 0)){
      formIsValid = false;
      errors["products"] = "Products is required";
    }

    setErrors(errors)
    return formIsValid;
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setDisabled(true)
    if(handleValidation()){
      let docRef = fb.metaCollection.doc(`shopify_${ref === 'rb' ? '' : `${ref}_`}products`)
      await docRef.get().then(async (doc) => {
        if (doc.exists && doc.data().hasOwnProperty('ids')) {
          let ids = doc.data().ids
          ids[pIndex] = product
          await docRef.update({ids}).then(() => {
            addAdminLog(
              'product_group_updated',
              `Updated the product ${ref} ${pIndex}`,
              `${ref}-${pIndex}`
            )
            props.history.push('/admin/product_groups');
          }).catch(err=> {
            setError(`Something went wrong-${err}`)
            setDisabled(false)
          });
        }
      })
      fb.metaCollection.doc(`PartnersPrices`).update(prices)
    }else{
      setDisabled(false)
    }
  }

  const handleSave = async () => {
    setDisabledSave(true)
    if(handleValidation()){
      let docRef = fb.metaCollection.doc(`shopify_${ref === 'rb' ? '' : `${ref}_`}products`)
      await docRef.get().then(async (doc) => {
        if (doc.exists && doc.data().hasOwnProperty('ids')) {
          let ids = doc.data().ids
          ids[pIndex] = product
          await docRef.update({ids}).then(() => {
            addAdminLog(
              'product_group_updated',
              `Updated the product ${ref} ${pIndex}`,
              `${ref}-${pIndex}`
            )
            setSuccessMessage("Product group updated successfully!")
            setTimeout(() => {
              setSuccessMessage('')
              setDisabledSave(false)
            }, 3000)
          }).catch(err=> {
            setError(`Something went wrong-${err}`)
            setDisabled(false)
          });
        }
      })
      fb.metaCollection.doc(`PartnersPrices`).update(prices)
    }else{
      setDisabledSave(false)
    }
  }

  const changeProduct = (e,field) => {
    let value = e.target.value
    setProduct(prev => ({...prev, [field]: value}))
  }

  const changePrice = (e,field) => {
    let p = {...prices}
    p[field] = parseInt(e.target.value*100)
    setPrices({...p})
  }

  const changeProducts = (e,i) => {
    let prs = [...product.products]
    prs[i] = {...prs[i], ref: e.target.value}
    setProduct(prev => ({...prev, products: prs}))
  }

  const changeAllergy = (e,i) => {
    let prs = [...product.products]
    let updatedProduct = { ...prs[i] }
    if (e.target.value === "") {
      delete updatedProduct.allergy
    } else {
      updatedProduct.allergy = e.target.value === "true"
    }
    prs[i] = updatedProduct
    setProduct(prev => ({ ...prev, products: prs }))
  }

  const deleteProduct = (i) => {
    let prs = [...product.products]
    prs.splice(i, 1);
    setProduct(prev => ({ ...prev, products: prs }))
  }

  const addProduct = () => {
    let prs = [...product.products]
    prs.push({ref: ''})
    setProduct(prev => ({ ...prev, products: prs }))
  }

  return (<div className="content">
    <Container fluid>
      <Row>
        <Col md={12}>
          {error &&
            <Alert bsStyle="danger">
              <span>{error}</span>
            </Alert>
          }
          {successMessage &&
            <Alert bsStyle="success">
              <span>{successMessage}</span>
            </Alert>
          }
          <Card
            title="Edit Product Group"
            button={
              <Link to={`/admin/product_groups`} className="btn btn-success pull-left card-back-button libi-admin-btn"> Back</Link>
            }
            content={
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <FormLabel>Shopify ids</FormLabel>
                      {ref === 'rb' ?
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter an id"
                          name="id"
                          value= {product.id}
                          onChange={(e) =>  changeProduct(e,'id')}
                        />
                        :
                        <StringArrayInput
                          placeholder="Enter an id"
                          onChange={(value) =>  setProduct(prev => ({...prev, id: value}))}
                          value={product.id}
                        />
                      }
                      <span className="help-block">{errors.id}</span>
                    </FormGroup>
                  </Col>
                  <Col md={6}></Col>
                </Row>
                <Row>
                  <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Title</FormLabel>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="name"
                        value= {product.name}
                        onChange={(e) =>  changeProduct(e,'name')}
                      />
                      <span className="help-block">{errors.name}</span>
                    </FormGroup>
                  </div>
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Order</FormLabel>
                      <select
                        className= "form-control"
                        name= "order"
                        value={product.order}
                        onChange={(e) =>  changeProduct(e,'order')}
                      >
                        <option value="">Select Order</option>
                        {orderOptions()}
                      </select>
                      <span className="help-block">{errors.order}</span>
                    </FormGroup>
                  </div> : null}
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Price UK</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        value= {prices[`${ref}${product?.name?.replace(/ /g, '')}PricePartner0UK`]/100 || ''}
                        onChange={(e) =>  changePrice(e,`${ref}${product.name.replace(/ /g, '')}PricePartner0UK`)}
                      />
                      <span className="help-block">{errors.uk}</span>
                    </FormGroup>
                  </div> : null}
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Price HU</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        value= {prices[`${ref}${product?.name?.replace(/ /g, '')}PricePartner0HU`]/100 || ''}
                        onChange={(e) =>  changePrice(e,`${ref}${product.name.replace(/ /g, '')}PricePartner0HU`)}
                      />
                      <span className="help-block">{errors.hu}</span>
                    </FormGroup>
                  </div> : null}
                </Row>
                {ref !== 'rb' ? <Row>
                  <Col md={12}>
                    {product.products && product.products.map((p,i) => {
                      return <Row key={i}>
                        <Col md={6}>
                          <FormGroup>
                            <FormLabel>Product</FormLabel>
                            <select
                              className= "form-control"
                              name="product"
                              value={p.ref}
                              onChange={(e) =>  changeProducts(e,i)}
                            >
                              <option value="">Select Product</option>
                              {products.map((pr,j) => <option key={j} value={pr.ref}>{pr.title}</option>)}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md={5}>
                          <FormGroup>
                            <FormLabel>Allergy</FormLabel>
                            <select
                              className="form-control"
                              name="allergy"
                              value={p.allergy}
                              onChange={(e) =>  changeAllergy(e,i)}
                            >
                              <option value="">Not selected</option>
                              <option value="true">Allergy</option>
                              <option value="false">Non-Allergy</option>
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md={1}>
                          <FormGroup>
                            <FormLabel></FormLabel>
                            <a href="#" onClick={() => {deleteProduct(i)}}><i className="fa fa-times" /></a>
                          </FormGroup>
                        </Col>
                      </Row>
                    })}
                  </Col>
                  <Col md={12}>
                    <Button
                      className="btn-fill libi-admin-btn mb-2"
                      bsStyle="success"
                      type="button"
                      onClick={() => addProduct()}
                    >
                      Add product
                    </Button>
                  </Col>
                  <span className="help-block">{errors.products}</span>
                </Row> : null}

                <Row></Row>
                <Button
                  className="btn-fill pull-right libi-admin-btn"
                  bsStyle="info"
                  type="submit"
                  disabled={disabled}
                >
                  {disabled ? 'Loading..' : 'Update'}
                </Button>
                <Link
                  to={`#`}
                  className="btn-fill pull-right btn btn-info libi-admin-btn"
                  onClick={() => handleSave()}
                  style={{marginRight: '18px'}}
                >
                  {disabledSave ? 'Loading..' : 'Save'}
                </Link>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    </Container>
  </div>)
}

export default EditProductGroup;
